module.exports = __webpack_public_path__ + "static/media/BannerImage.89f3a419.png";